// extracted by mini-css-extract-plugin
export default {"hed":"Yl","blend":"Zl","resultsBox":"am","left":"bm","right":"cm","center":"em","base":"fm","milk":"gm","text":"hm","hyroxresult":"im","margin":"jm"};
    if(module.hot) {
      // 1714654881740
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  